import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import { translate } from 'services/i18nService';
import Button from 'components/Button/Button';
import ConditionalThumbnailPlayer from 'components/StreamPlayer/ConditionalThumbnailPlayer';
import routeDefinitions from 'enum/routeDefinitions';
import { generateID } from 'utils/helpers';

import styles from './SimilarBroadcasts.css';


const IDS = {
  prefix: 'SmOrU3pm',
  element: 'SimilarBroadcastsMobile',
  thumbnail: 'thumbnail',
  moreCams: 'moreCams',
};

const makeId = generateID(IDS.prefix, IDS.element);

const SimilarBroadcastsMobile = (props) => {
  const { similarCams, accessLevel, isAdmin, genderPreference, approvedAccounts } = props;
  const handleRedirect = useCallback(() => {
    window.location = routeDefinitions.root;
  }, []);

  return (
    <div className={styles.similarWrapMobile}>
      <p>{translate('v2profile.shows.over')}</p>
      <Grid container={true} spacing={1}>
        {similarCams.slice(0, 4).map((user) => (
          <Grid key={user.userId} item={true} xs={6}>
            <div
              className={styles.thumbnailWrapper}
            >
              <ConditionalThumbnailPlayer
                accessLevel={accessLevel}
                approvedAccounts={approvedAccounts}
                genderPreference={genderPreference}
                isAdmin={isAdmin}
                showFlags={false}
                user={user}
              />
            </div>
          </Grid>
        ))}
      </Grid>
      <Button
        colour="orange"
        id={makeId(IDS.moreCams)}
        label={translate('v2profile.view.more.cams')}
        onClick={handleRedirect}
      />
    </div>
  );
};

SimilarBroadcastsMobile.propTypes = {
  accessLevel: PropTypes.number.isRequired,
  approvedAccounts: PropTypes.object.isRequired,
  genderPreference: PropTypes.string.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  similarCams: PropTypes.array.isRequired,
};

export default SimilarBroadcastsMobile;
